declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    env?: Record<string, string | undefined>
  }
}

const getValue = (name: string) => {
  // todo: handle missing config
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  return window?.env?.[name]!
}

export const config = {
  environment: getValue('ENVIRONMENT'),
  appVersion: getValue('APP_VERSION'),
  metapicApiUrl: getValue('METAPIC_API_URL'),
  notificationApiUrl: getValue('NOTIFICATION_API_URL'),
  socialMediaApiUrl: getValue('SOCIAL_MEDIA_API_URL'),
  financeApiUrl: getValue('FINANCE_API_URL'),
  mediaBaseUrl: getValue('MEDIA_BASE_URL'),
  advertiserAppUrl: getValue('ADVERTISER_APP_URL'),
  agencyAppUrl: getValue('AGENCY_APP_URL'),
  creatorAppUrl: getValue('CREATOR_APP_URL'),
  reportsAppUrl: getValue('REPORTS_APP_URL'),
  unleash: {
    proxyUrl: getValue('UNLEASH_PROXY_URL'),
    clientKey: getValue('ADMIN_APP_UNLEASH_CLIENT_KEY'),
  },
  sentryDsn: getValue('ADMIN_APP_SENTRY_DSN'),
  legacyAdminAppUrl: getValue('LEGACY_ADMIN_APP_URL'),
  powerBiUrl: getValue('POWER_BI_URL'),
  linkRedirectServiceUrl: getValue('LINK_REDIRECT_SERVICE_URL'),
  novuApiUrl: getValue('NOVU_API_URL'),
  novuSocketUrl: getValue('NOVU_SOCKET_URL'),
  novuAppIdentifier: getValue('NOVU_APP_IDENTIFIER'),
  oryApiUrl: getValue('ORY_API_URL'),
  identityAppUrl: getValue('IDENTITY_APP_URL'),
  zezamRedirectUrl: getValue('ZEZAM_REDIRECT_URL'),
  zezamApiUrl: getValue('ZEZAM_API_URL'),
  myPagePublicUrl: getValue('MY_PAGE_PUBLIC_URL'),
}

export type RuntimeConfig = typeof config
